import { SYSTEM_INPUT } from './topics';
import { Joi, actionCreator, objectSchemaOf } from '../helpers';

export const AWAKE = 'SYSTEM/AWAKE' as const;

export interface IAwakeActionPayload {
  consoleId: string;
}

export const awakeActionPayloadSchema = objectSchemaOf<IAwakeActionPayload>({
  consoleId: Joi.string().required(),
});

export interface IAwakeAction {
  type: typeof AWAKE;
  payload: IAwakeActionPayload;
}

export const awakeActionSchema = objectSchemaOf<IAwakeAction>({
  type: Joi.string().required().valid(AWAKE),
  payload: awakeActionPayloadSchema.required(),
});

export const awake = actionCreator({
  type: AWAKE,
  topic: SYSTEM_INPUT,
  schema: awakeActionSchema,
});
